<template>
  <form v-on:submit="save">

    <div id="app">
      <div class="card card-info" id="divEdit" runat="server">
        <div class="card-header with-border">
          <h3 class="card-title">Interview Marks</h3>
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-md-6">
              <div class="form-group">
                <label>Interview *</label>
                <select v-model="seltest" class="form-control" v-on:change="loadCandidates()" required>
                  <option selected="selected" disabled="disabled" value="">--Select Interview--</option>
                  <option v-for="item in test" v-bind:value="item.id">{{item.name}} </option>
                </select>
              </div>
            </div>

          </div>

          <div class="row" v-show="candidates.length > 0">
            <div class="col-md-12">
              <label>Students</label>
              <div style="max-height: 700px; overflow-y: scroll">
                <table id="example2" class="table table-sm table-bordered table-color table-striped">
                  <thead class="bg-info text-white">
                    <tr>
                      <th style="width: 3px;">Sr.</th>
                      <th style="width: 10%; text-align: center">Form No</th>
                      <th style="width: 17%;">Name</th>
                      <th style="width: 17%;">Father Name</th>
                      <th style="width: 190px;">Status</th>
                      <th style="width: 100px; text-align: center">Total Marks</th>
                      <th style="width: 100px; text-align: center">Marks Obt.</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="4" style="text-align: center">
                        Apply on All
                      </td>
                      <td>
                        <select class="form-control" v-on:change="applyAll()" v-model="appall">
                          <option value="">--Select--</option>
                          <option value="Present">Present</option>
                          <option value="Absent">Absent</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-for="(item, index) in candidates">
                      <td style="text-align: center">{{index + 1}}</td>
                      <td style="width: 10%; text-align: center">{{item.FormNo}}</td>
                      <td style="">{{item.Name}}</td>
                      <td style="">{{item.FatherName}}</td>
                      <td>
                        <select class="form-control" v-model="item.Status">
                          <option value="">--Select--</option>
                          <option value="Present">Present</option>
                          <option value="Absent">Absent</option>
                        </select>
                        <!--<input type="checkbox" style="float:right" v-model="item.Present" />-->
                      </td>
                      <td style="text-align: center">{{item.TotalMarks}}</td>
                      <td style="text-align: center">
                        <input type="text" v-model="item.MarksObtained" v-bind:disabled="item.Present == false" required  class="form-control"  v-on:change="marksChange(index)" v-mask="'#####'"/>
                      </td>
                      <td>
                        <input class="form-control" v-model="item.Remarks" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer" style="text-align: right">
          <button type="submit" class="btn btn-success">Save</button>
          <button type="button" runat="server" v-on:click="clear()" class="btn btn-danger">Cancel</button> <!--//onclick="location.reload()"-->
        </div>
      </div>
    </div>
  </form>
</template>


<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        test: '',
        candidates: [],
        seltest: '',
        disabled: 0,
        appall: ''
      }
    },

    created: function () {
      this.loadTest();
    },
    mounted: function () {
    },
    updated: function () {
    },


    methods: {
      loadTest() {
        var vm = this;
        axios.post('/api/AdmissionApi/loadInterview')
          .then(function (res) {
            vm.test = res.data.test;
          })
          .catch(function (res) {

          });
      },

      loadCandidates() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadCandidates?ID=' + vm.seltest)
          .then(function (res) {
            vm.candidates = res.data.candidates;
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },

      marksChange(ind) {
        var tot = Number(this.candidates[ind].TotalMarks);
        var obt = Number(this.candidates[ind].MarksObtained);

        if (tot < obt) {
          alert("Obtained marks cannot be greater the total marks");
          this.candidates[ind].MarksObtained = 0;
        }
      },

      applyAll() {
        var vm = this;
        this.candidates.forEach(function (item) {
          item.Status = vm.appall;
        });
      },

      clear() {
        this.candidates = [];
        this.seltest = "";
      },

      save(e) {


        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/admissionApi/InterviewMarksEntry', {
          candidates: vm.candidates,
        })
          .then(function (res) {
            endReq();
            //var result = res.data.replace('{"d":null}', '');
            //var rs = JSON.parse(result);
            if (!res.data.status ) {
              var error = rs.error;
              for (var i = 0; i < error.length; i++) {
                toastr.error(error[i] + " is required", "Error!");
              }
            }
            else if (res.data.status) {
              toastr.success("Saved successfully", "Done!");
              vm.reset();
            }
            else {
              console.log(res.data);
            }

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })


      },







    }

  });
  

</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/interviewMarksEntryForm.vue